import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PlaybookPredefinedTasksOverride from 'Overrides/PlaybookPredefinedTasks';
import useResource from 'Hooks/useResource';
import Button from '@material-ui/core/Button';
import { dispatchActionItemRefresh } from 'Hooks/useRefreshEvent';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import PredefinedTaskChecklist from './PredefinedTaskChecklist';
import PredefinedTaskGroupCount from './PredefinedTaskGroupCount';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(3),
  },
  submitButton: {
    color: theme.palette.common.white,
    width: '100%',
    height: theme.spacing(5),
    borderRadius: 0,
  },
});

const PredefinedTaskSetMultiPicklist = ({
  className,
  classes,
  predefinedTaskSet,
}) => {
  const { resource: taskSetResource, setAttribute: setTaskSetResource } = useResource(predefinedTaskSet);

  const allTasksFromSet = taskSetResource.attr('predefinedTasks')
    .overrideMeta(PlaybookPredefinedTasksOverride)
    .resources()
    .list();

  // Render nothing if there are no predefined tasks to display
  if (allTasksFromSet.length === 0) {
    return null;
  }

  const onTaskSetSubmit = async () => {
    try {
      await taskSetResource.submit({ linkArgs: { raw: true } });
      dispatchActionItemRefresh();
      displaySuccess('Tasks successfully created');
    } catch (e) {
      displayErrorMessage(e, 'Error while creating tasks');
    }
  };

  const groupTaskCount = allTasksFromSet.reduce((acc, currentTask) => {
    const selectedTasks = currentTask.attr('tasks');
    const optionsList = currentTask.meta().field('tasks').options().list();
    const filteredOptionsList = optionsList.filter(option => selectedTasks.includes(option.attr('id')));
    // Iterate over selected options and count based on group.
    filteredOptionsList.forEach((task) => {
      const group = task.attr('group');
      if (acc[group]) {
        acc[group] += 1;
      } else {
        acc[group] = 1;
      }
    });
    return acc;
  }, { Client: 0, Planner: 0 });

  const isTaskSelected = Object.keys(groupTaskCount).some(group => groupTaskCount[group] > 0);

  return (
    <div
      className={classNames(classes.root, className)}
    >
      {allTasksFromSet.map(res => (
        <PredefinedTaskChecklist taskResource={res} setTaskSetResource={setTaskSetResource} />
      ))}
      <PredefinedTaskGroupCount groupTaskCount={groupTaskCount} />
      <Button
        variant="contained"
        color="primary"
        disabled={!isTaskSelected}
        className={classes.submitButton}
        onClick={onTaskSetSubmit}
        disableElevation
      >
        {"Create To Do's & Tasks"}
      </Button>
    </div>
  );
};

PredefinedTaskSetMultiPicklist.defaultProps = {
  className: '',
};

PredefinedTaskSetMultiPicklist.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  predefinedTaskSet: PropTypes.object.isRequired,
};

export default withStyles(styles)(PredefinedTaskSetMultiPicklist);
